<!--
Support & Wellbeing screen.
Contains components for rendering the select options and the content based on the selection made
@author dgm11b
-->

<template>
    <div id="contain" class="container">
        <Nav name="Wellbeing Support" :step="true" />
        <WellbeingContent
            :content="content"
        />
        <div id="pusher"></div>
        <Footer active="wellbeing"/>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Nav from '@/components/Navbar.vue'
import WellbeingSelect from '@/components/wellbeing/WellbeingSelect.vue'
import WellbeingContent from '@/components/wellbeing/WellbeingContent.vue'
import Footer from '@/components/FooterMenu.vue'

const content = ref([])

function updateContent(selection) {
    content.value = selection
}


</script>

<style lang="scss" scoped>
/* Overriding default 1rem (16px) margin-bottom */
p {
    margin-bottom: 12px;
}
</style>